import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { GRAY_API_URL } from "./http.config";

@Injectable()
export class ApiService {
  /**
   * Format: {platform}:{appIdentifier}:{appVersion}:{buildNumber}
   * // TODO: Need to extend in future. We need more information for debug/log process
   * @private
   */
  private readonly appResourceHeaderValue = "web:bundle:1:1";

  constructor(
    private http: HttpClient,
    @Inject(GRAY_API_URL) private apiUrl: string,
  ) {
  }

  private getDefaultHeaders(): HttpHeaders {
    return new HttpHeaders({
      "X-Client-Resource": this.appResourceHeaderValue,
    });
  }

  get(path: string, queryString = ''): Observable<any> {
    const reqUrl = `${this.apiUrl}${path}${queryString}`;

    const time = (new Date()).getTime();
    let timeSuffix = `?tm=${time}`;
    if (reqUrl.includes('?')) {
      timeSuffix = `&tm=${time}`;
    }

    return this.http.get(`${reqUrl}${timeSuffix}`, {
      headers: this.getDefaultHeaders(),
    })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: object = {}): Observable<any> {
    return this.http.put(
      `${this.apiUrl}${path}`,
      body, {
        headers: this.getDefaultHeaders(),
      }
    ).pipe(catchError(this.formatErrors));
  }

  putToUrl(url: string, data: any): Observable<any> {
    return this.http.put(`${url}`, data, {
      headers: this.getDefaultHeaders(),
    });
  }

  getFromUrl(url: string): Observable<any> {
    return this.http.get(`${url}`, {
      headers: this.getDefaultHeaders(),
    });
  }

  patch(path: string, body: object): Observable<any> {
    return this.http.patch(
      `${this.apiUrl}${path}`,
      body, {
        headers: this.getDefaultHeaders(),
      }
    ).pipe(catchError(this.formatErrors));
  }

  post(path: string, body: any): Observable<any> {
    return this.http.post(
      `${this.apiUrl}${path}`,
      body, {
        headers: this.getDefaultHeaders(),
      }
    ).pipe(catchError(this.formatErrors));
  }

  delete(path: string): Observable<any> {
    return this.http.delete(
      `${this.apiUrl}${path}`, {
        headers: this.getDefaultHeaders(),
      }
    ).pipe(catchError(this.formatErrors));
  }


  private formatErrors(error: any): Observable<any> {
    return throwError(error.error);
  }

}
